/**
 * Leitura dos números colados da planilha — MESMA regra do backend
 * (DisparoFilaService.analisarNumeros + ContatoNormalizerService). Serve só
 * para a prévia na tela enquanto a pessoa cola; quem decide de verdade é o
 * servidor, ao criar o envio.
 */

export function normalizarTelefone(valor) {
  if (!valor) return null;
  let limpo = String(valor).replace(/[^\d+]/g, '');
  if (limpo.startsWith('+')) limpo = limpo.slice(1);
  limpo = limpo.replace(/^0+/, '');
  if (!limpo) return null;
  if (limpo.length === 10 || limpo.length === 11) limpo = `55${limpo}`;
  return limpo;
}

function telefoneLocalBrasil(valor) {
  const limpo = String(valor || '').replace(/\D/g, '');
  if (limpo.length === 10 || limpo.length === 11) return limpo;
  if (limpo.startsWith('55') && (limpo.length === 12 || limpo.length === 13)) return limpo.slice(2);
  return null;
}

/** O número e a forma com/sem o 9º dígito (são a mesma pessoa). */
export function variantesTelefone(valor) {
  const normalizado = normalizarTelefone(valor);
  if (!normalizado) return [];
  const local = telefoneLocalBrasil(normalizado);
  const variantes = new Set([normalizado]);
  if (local && local.length === 11 && local[2] === '9') {
    variantes.add(normalizarTelefone(`${local.slice(0, 2)}${local.slice(3)}`));
  }
  if (local && local.length === 10) {
    variantes.add(normalizarTelefone(`${local.slice(0, 2)}9${local.slice(2)}`));
  }
  return [...variantes].filter(Boolean);
}

/** Brasil: 55 + DDD + 8/9 dígitos. Fora do Brasil: 10 a 15 dígitos. */
export function numeroValido(n) {
  if (!n) return false;
  if (n.startsWith('55')) return /^55[1-9]\d\d{8,9}$/.test(n);
  return /^[1-9]\d{9,14}$/.test(n);
}

/**
 * Cada linha/célula é um candidato; texto sem dígito (cabeçalho, nome) é
 * ignorado. Separa por quebra de linha, tab (colunas coladas do Excel), ; , e |.
 */
export function analisarNumeros(texto) {
  const validos = [];
  const vistos = new Set();
  let duplicados = 0;
  let invalidos = 0;
  const exemplosInvalidos = [];
  for (const bruto of String(texto || '').split(/[\r\n\t;,|]+/)) {
    const token = bruto.trim();
    if (!token || !/\d/.test(token)) continue;
    const normalizado = normalizarTelefone(token);
    if (!numeroValido(normalizado)) {
      invalidos += 1;
      if (exemplosInvalidos.length < 20) exemplosInvalidos.push(token.slice(0, 40));
      continue;
    }
    const variantes = variantesTelefone(normalizado);
    if (variantes.some((v) => vistos.has(v))) {
      duplicados += 1;
      continue;
    }
    variantes.forEach((v) => vistos.add(v));
    validos.push(normalizado);
  }
  return { validos, duplicados, invalidos, exemplosInvalidos };
}

export default analisarNumeros;
